<template>
    <div class="kt-portlet__head">
        <form class="isprint-filter" autocomplete="off">
            <div class="form-group ">
                <label>Tipologia Contratto:</label><br>
                <select class="form-control form-control-sm" style="width: 150px;" v-model="search.FK_ID_TIPO.VALUE">
                    <option value="">Luce / Gas</option>
                    <option value="1">Luce</option>
                    <option value="2">Gas</option>
                </select>
            </div>
            <div class="form-group ">
                <label>Cliente:</label><br>
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Denominazione"
                    type="text" style="width:150px" v-model="search.DENOMINAZIONE.VALUE">
            </div>
            <div class="form-group ">
                <label>Agente:</label><br>
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Agente"
                    type="text" style="width:150px" v-model="search.DESCRIZIONE_AGENTE.VALUE">
            </div>
            <div class="form-group ">
                <label>Tipologia Calcolo:</label><br>
                <select class="form-control form-control-sm" style="width: 150px;"
                    v-model="search.FK_ID_CALCOLO_MODALITA_IMPORTO.VALUE">
                    <option value="">Fisso / Indicizato</option>
                    <option value="1">Fisso</option>
                    <option value="2">Indicizzato</option>
                </select>
            </div>
            <div class="form-group ">
                <label>Fornitore:</label><br>
                <select class="form-control form-control-sm" style="width: 150px;"
                    v-model="search.FK_ID_FORNITORE.VALUE">
                    <option value="">Tutti i fornitori</option>
                    <option v-for="fornitore in arrayFornitori" v-bind:value="fornitore.ID_FORNITORE"
                        v-bind:key="fornitore.ID_FORNITORE">
                        {{ fornitore.DENOMINAZIONE_FORNITORE }}
                    </option>
                </select>
            </div>
            <div class="form-group ">
                <label>Sadenza(Data da)</label><br>
                <DatePicker placeholder="data inizio" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_SCADENZA.VALUE_FROM"></DatePicker>
            </div>
            <div class="form-group ">
                <label>Sadenza(Data a)</label><br>
                <DatePicker placeholder="data fine" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_SCADENZA.VALUE_TO"></DatePicker>
            </div>
            <div class="form-group ">
                <label>Attivazione(Data da)</label><br>
                <DatePicker placeholder="data inizio" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_ATTIVAZIONE.VALUE_FROM"></DatePicker>
            </div>
            <div class="form-group ">
                <label>Attivazione(Data a)</label><br>
                <DatePicker placeholder="data fine" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_ATTIVAZIONE.VALUE_TO"></DatePicker>
            </div>
            <div class="form-group ">
                <label>Descrizione Offerta:</label><br>
                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                    placeholder="Descrizione Offerta" type="text" style="width:150px"
                    v-model="search.DESCRIZIONE_OFFERTA.VALUE">
            </div>
            <button class="btn btn-success float-right btn-sm my-2 my-sm-3"
                v-on:click="modificaContratto({ ID_CONTRATTO: 0 })" style="margin-top:26px"><i
                    class="fas fa-file-signature"></i> Crea Contratto</button>
        </form>
    </div>
    <div class="isprint-grid-container">
        <table class="isprint-grid shadow">
            <thead class="isprint-grid-thead">
                <tr style="left:0px;background:#127787;color:#fff">
                    <th style="width:29%"><span>Cliente</span></th>
                    <th style="width:8%"><span>POD/PDR</span></th>
                    <th style="width:8%"><span>Codice Contratto</span></th>
                    <th style="width:8%"><span>Data Attivazione</span></th>
                    <th style="width:8%"><span>Data Scadenza</span></th>

                    <th style="width:10%"><span>Fornitore</span></th>
                    <th style="width:11%"><span>Agente</span></th>

                    <th style="width:11%"><span>Descrizione Offerta</span></th>
                    <th style="width:7%"><span>Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-bind:key="contratto.ID_CONTRATTO"
                    v-for="contratto in paginatedList.arr">
                    <td style="width:29%">
                        <div class="float-left" style="width:51px">
                            <span class="badge badge" v-if="contratto.FK_ID_TIPO == 1" style="font-size:28px">
                                <i class="fas fa-lightbulb text-warning" aria-hidden="true"></i>
                            </span>
                            <span class="badge badge" v-else-if="contratto.FK_ID_TIPO == 2" style="font-size:28px">
                                <i class="fas fa-gas-pump text-danger" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="float-left " style="padding-top:2px">
                            <strong>{{ contratto.DENOMINAZIONE != null ? contratto.DENOMINAZIONE : '' }}</strong>
                            <br />
                            <small>{{ contratto.CODICE_CLIENTE }}</small>
                        </div>
                    </td>
                    <td style="width:8%">
                        {{ contratto.FK_ID_TIPO == 1 ? contratto.POD : contratto.PDR }}
                    </td>
                    <td style="width:8%">
                        {{ contratto.NUMERO_CONTRATTO }}
                    </td>
                    <td style="width:8%">
                        <span>
                            {{ contratto.DATA_ATTIVAZIONE != "0000-00-00" ?
                            filters.formatDate(contratto.DATA_ATTIVAZIONE) : '01/01/2000'}}
                        </span>
                    </td>
                    <td style="width:8%">
                        <span class="badge" v-bind:class="getClassDataScadenza(contratto)">
                            {{ filters.formatDate(contratto.DATA_SCADENZA) }}
                        </span>
                    </td>


                    <td style="width:10%">
                        <img v-if="contratto.URL_IMMAGINE != ''" :src="getPathImg(contratto.URL_IMMAGINE)"
                            class="img-responsive" style="max-height:48px; ">
                        <span v-else class="badge badge"><strong style="font-size:10px"><i
                                    class="fal fa-warehouse"></i>{{ ' ' + contratto.DENOMINAZIONE_FORNITORE
                                }}</strong></span>
                    </td>
                    <td style="width:11%">
                        <i class="fad fa-user-secret" aria-hidden="true"></i>
                        {{ contratto.DESCRIZIONE_AGENTE }}
                    </td>

                    <td style="width:11%">
                        <i v-if="contratto.FK_ID_CALCOLO_MODALITA_IMPORTO == 1" class="fad fa-thumbtack"
                            aria-hidden="true"></i>
                        <i v-else class="fad fa-chart-bar" aria-hidden="true"></i>
                        {{ contratto.DESCRIZIONE_OFFERTA }}
                    </td>

                    <td style="width:7%">
                        <div class="btn-group float-right" role="group" aria-label="Basic example">
                            <button :disabled="contratto.URL == ''" data-toggle="tooltip" data-placement="top"
                                class="btn btn-primary btn-sm float-right" v-on:click="openDocumento(contratto)"><i
                                    class="fal fa-file-export"></i></button>
                            <button data-toggle="tooltip" data-placement="top" title="Modifica il contratto"
                                class="btn btn-warning btn-sm float-right" v-on:click="modificaContratto(contratto)"><i
                                    class="fal fa-pencil"></i></button>
                            <button data-toggle="tooltip" data-placement="top" title="Elimina il contratto"
                                class="btn btn-danger btn-sm float-right" v-on:click="eliminaContratto(contratto)"><i
                                    class="fal fa-trash-alt"></i></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
            :numpagine="search.PAGINATION.LENGTH"></Pagine>
    </div>
    <PopUpContratto :ref="'modalContratto'" @contratto-salvato="getContratti()"></PopUpContratto>
</template>
<script>

import Pagine from '@/components/utils/Pagine.vue'
import DatePicker from '@/components/utils/DatePicker.vue'
import Select2 from '@/components/utils/Select2.vue'
import PopUpContratto from '../components/PopUpContratto.vue'


export default {
    name: "Contratti",
    components: {
        Pagine,
        DatePicker,
        PopUpContratto
    },
    data: function () {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                ID_CONTRATTO: { TYPE: 'TEXT', VALUE: '' },
                SPREAD: { TYPE: 'TEXT', VALUE: '' },
                FK_ID_CLIENTE: { TYPE: 'TEXT', VALUE: '' },
                FK_ID_TIPO: { TYPE: 'COMBO', VALUE: '' },
                FK_ID_CALCOLO_MODALITA_IMPORTO: { TYPE: 'COMBO', VALUE: '' },
                DENOMINAZIONE: { TYPE: 'TEXT', VALUE: '' },
                DESCRIZIONE_OFFERTA: { TYPE: 'TEXT', VALUE: '' },
                FK_ID_FORNITORE: { TYPE: 'COMBO', VALUE: '' },
                DATA_SCADENZA: { TYPE: 'DATE_RANGE', VALUE_FROM: '', VALUE_TO: '' },
                DATA_ATTIVAZIONE: { TYPE: 'DATE_RANGE', VALUE_FROM: '', VALUE_TO: '' },
                DESCRIZIONE_AGENTE: { TYPE: 'TEXT', VALUE: '' },
            },
            arrayContratti: new Array(),
            arrayFornitori: new Array(),
            contrattoSelezionato: { immagine: '' },
        }
    },
    methods: {
        getPathImg: function (url) {
            return utils.BASE_API + "../../UPLOAD" + url;
        },

        modificaContratto: function (contratto) {
            this.contrattoSelezionato = utils.clone(contratto)
            if (contratto.ID_CONTRATTO == 0) {
                this.$refs.modalContratto.openSchedaContratto(this.contrattoSelezionato, true);
            } else {
                this.$refs.modalContratto.openSchedaContratto(this.contrattoSelezionato, false);
            }


        },
        getContratti: function () {
            global.utils.get('/es/contratti', {}, (response) => {
                this.arrayContratti = response.data;
            });
        },
        getContratto: function (contratto) {
            global.utils.get('/es/contratto', { ID_CONTRATTO: contratto.ID_CONTRATTO }, (response) => {
                this.contrattoSelezionato = utils.clone(response.data);

            })
        },
        eliminaContratto: function (contratto) {
            utils.alert.confirm("Sei sicuro di voler eliminare il contratto selezionato? Verrà eliminate anche le informazioni dallo scadenzario", () => {
                global.utils.delete('/es/contratto', { ID_CONTRATTO: contratto.ID_CONTRATTO }, (responseContratto) => {
                    if (responseContratto.esito == 0) {
                        utils.alert.success(responseContratto.messaggio);
                        this.getContratti()
                    }

                });
            }, this.$root);
        },
        salvaContratto: function () {
            //update
            if (this.contrattoSelezionato.ID_CONTRATTO > 0) {
                global.utils.put('/es/contratto', this.contrattoSelezionato, (response) => {
                    if (response.esito == 0) {
                        this.getContratti();
                        var modal = utils.closeModal('popUpContratto')
                        utils.alert.success(response.messaggio);
                    }
                });
            } else {
                //insert
                global.utils.post('/es/contratto', this.contrattoSelezionato, (response) => {
                    if (response.esito == 0) {
                        this.getContratti()
                        var modal = utils.closeModal('popUpContratto')
                        utils.alert.success(response.messaggio);
                    }
                });
            }
        },
        openDocumento: function (contratto) {
            window.open(utils.BASE_API + 'es/contratto/upload?ID_CONTRATTO=' + contratto.ID_CONTRATTO, '_blank')
        },
        getClassDataScadenza: function (contratto) {
            return contratto.CONTRATTO_VALIDO == 1 ? 'badge-success' : 'badge-danger';
        }
    },
    computed: {
        paginatedList() {
            var arr = utils.inGrid(this.arrayContratti, this.search);
            return arr;
        },
    },
    created: function () {
        //PRIMA FAI UNA GET FORNITORI CHE ALIMENTA UNA VARIABILE GLOBALE $arrayFornitori
        //NEL CALLBACK FAI LA GET CONTRATTI 
        global.utils.get('/es/fornitori', {}, (response) => {
            this.arrayFornitori = response.data;
            this.getContratti()
        });

    }
}
</script>